import { gql } from "@apollo/client"; import { useLazyQuery } from "@apollo/client/react";
import { Box, Checkbox, Chip, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';

import './seccionDelegacion.scss';
export default function SeccionDelegacion({
  delegacionesSeleccionadas,
  setDelegacionesSeleccionadas,
  delegacionOrigen,
  setDelegacionOrigen,
  regiones,
  setRegiones,
  delegaciones,
  setDelegaciones,
  textoDelegacionOrigen = 'Deleg. Origen',
  delegacionesUsuario,
  isFromGestionProfesional
}) {

  // región actual seleccionada
  const [region, setRegion] = useState(-1);
  // delegaciones a mostrar de la región actual
  const [delegacionesRegion, setDelegacionesRegion] = useState([]);

  // indica si todas las delegaciones de la región están todas seleccionadas
  const [todasSeleccionadas, setTodasSeleccionadas] = useState(false);


  useEffect(() => {
    getRegiones();
    getDelegaciones({ variables: { idRegion: 0 } });
  }, []);

  // useEffect(() => {
  //     // console.log("cambio deleg --> ", delegaciones);
  //     console.log("deleg seleccionadas: ", delegacionesSeleccionadas, delegacionesSeleccionadas.filter(d => d === 1).length);
  //     // // si el usuario tiene asignada CASA CENTRAL --> marco todas las delegaciones
  //     // console.log("delegaciones init: ", delegaciones);
  //     if (delegacionesSeleccionadas.filter(d => d === 1).length > 0) {
  //         let asignar = [];
  //         delegaciones.map((d) => {
  //             asignar.push(d.idDelegacion);
  //         });

  //         setDelegacionesSeleccionadas(asignar);
  //         console.log("seteado")
  //     }
  // }, [delegaciones]);

  // useEffect(() => {
  //     if (region === 0) {
  //         marcarTodasDelegaciones(true);
  //     }
  // }, [delegacionesRegion]);

  const QGetRegiones = gql`
        query QGetRegiones{
            regiones
                {
                    success,
                    error,
                    valorEsperado {
                        idRegion,
                        descripcion
                    }
                }
        }`;

  const [getRegiones, { error, data: dataRegiones }] = useLazyQuery(QGetRegiones, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!dataRegiones?.regiones?.success) return;
    const dataAll = dataRegiones.regiones.valorEsperado;
    setRegiones(dataAll);
  }, [dataRegiones]);

  const QGetDelegaciones = gql`
        query QGetDelegaciones ($idRegion: Int!) {
            delegaciones (idRegion: $idRegion)
                {
                    success,
                    error,
                    valorEsperado {
                        idRegion,
                        region,
                        idDelegacion,
                        descripcion,
                        activo
                    }
                }
        }`;

  const [getDelegaciones, { data: dataDeleg }] = useLazyQuery(QGetDelegaciones, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!dataDeleg?.delegaciones?.success) return;
    setDelegaciones(dataDeleg.delegaciones.valorEsperado);
  }, [dataDeleg]);

  const handleChangeRegion = (e) => {
    let idRegionEvent = parseInt(e.target.value, 10);
    setRegion(idRegionEvent);
    setTodasSeleccionadas(false);
    mostrarDelegacionesRegion(idRegionEvent);
  };

  const mostrarDelegacionesRegion = (idRegion) => {
    // delegaciones de la región
    let delegacionesRegion = [];
    if (idRegion > 0) {
      delegacionesRegion = delegaciones.filter(
        (deleg) =>
          deleg.idRegion === idRegion && (
            //el siguiente filtro se aplica unicamente si "isFromGestionProfesional" es true, sino se ignora 

            !isFromGestionProfesional ||
            !!delegacionesUsuario?.find((d) => d.id === deleg.idDelegacion))

      );
    } else if (idRegion == 0) {
      // todas las delegaciones
      delegacionesRegion = delegaciones.filter(
        (deleg) => !isFromGestionProfesional || !!delegacionesUsuario?.find((d) => d.id === deleg.idDelegacion)
      );
    }

    setDelegacionesRegion(delegacionesRegion);
  };

  const handleCheckDelegacion = (e) => {
    // delegaciones
    const idDelegParam = parseInt(e.target.id, 10);

    setSeleccionDelegacion(idDelegParam, e.target.checked);
  };

  // Marca o desmarca una delegación como seleccionada
  // Parámetros: id: ID de la delegación. marca: true o false (checked)
  const setSeleccionDelegacion = (id, marca) => {
    if (marca) {
      setDelegacionesSeleccionadas([...delegacionesSeleccionadas, id]);
    } else {
      setDelegacionesSeleccionadas(delegacionesSeleccionadas.filter((deleg) => deleg !== id));
      // limpio el valor de la delegación de origen si está comprendida en la región
      if (delegacionOrigen === id) {
        setDelegacionOrigen(0);
      }
    }
  };


  const handleSeleccionarTodas = (e) => {
    marcarTodasDelegaciones(e.target.checked);
  };

  const marcarTodasDelegaciones = (opcion) => {
    // array final actualizado
    let regs = delegacionesSeleccionadas;

    // por cada delegación de la región actual seleccionada
    delegacionesRegion.map((deleg) => {
      // marco
      if (opcion) {
        // si no está la delegación la agrego
        const existe = regs.filter((i) => i === deleg.idDelegacion);
        if (existe.length == 0) {
          regs = [...regs, deleg.idDelegacion];
        }
        setTodasSeleccionadas(true);
      } else {
        // borro todas las delegaciones de la región como marcadas
        regs = regs.filter((d) => d !== deleg.idDelegacion);
        // limpio el valor de la delegación de origen si está comprendida en la región
        if (delegacionOrigen === deleg.idDelegacion) {
          setDelegacionOrigen(0);
        }
        setTodasSeleccionadas(false);
      }
    });

    setDelegacionesSeleccionadas(regs);
    mostrarDelegacionesRegion(region);
  };

  const handleDelegacionOrigen = (e) => {
    setDelegacionOrigen(parseInt(e.target.value, 10));
  };

  return (
    <>
      <div className='seccion-delegation-container'>
        <Grid
          container
          spacing={2}
          columns={{
            xs: 6
          }}>

          <Grid size={{ xs: 2.5 }}>
            <div className='delegation-grid-container'>
              <h4 className='seccion-delegation-title'>Delegaciones disponibles</h4>
              <Grid
                container
                direction="row"
                spacing={2}
                columns={{ xs: 1, md: 4 }}
                className='available-delegations-container'>

                <Grid size={{ xs: 1, md: 3 }}>
                  <FormControl sx={{ width: '100%' }} size="small">
                    <InputLabel id="select-region">Región</InputLabel>
                    <Select
                      labelId="select-region"
                      id="Region"
                      value={region}
                      label="Región"
                      onChange={handleChangeRegion}
                      sx={{ fontSize: '9pt' }}>

                      <MenuItem value={-1} sx={{ fontSize: '9pt' }}> Seleccionar Región </MenuItem>
                      {regiones?.map((reg, index) => {
                        return <MenuItem key={index} value={reg.idRegion} sx={{ fontSize: '9pt' }}>{reg.descripcion}</MenuItem>;
                      })}
                      <MenuItem value={0} sx={{ fontSize: '9pt' }}> TODAS </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 1 }}>
                  <FormControlLabel
                    control={<Checkbox checked={todasSeleccionadas} onChange={handleSeleccionarTodas} disabled={region === -1} />}
                    label={<Typography sx={{ fontSize: 13 }}>
                      Todos
                    </Typography>} />

                </Grid>
              </Grid>

              <Grid
                container
                spacing={0.5}
                columns={{ xs: 1, md: 3 }}
                justifyContent={'space-between'}>

                {delegacionesRegion && delegacionesRegion?.map((deleg, index) => {
                  return <Grid size={{ xs: 1, md: 1.5 }}>
                    <FormControlLabel control={
                      <Checkbox
                        checked={delegacionesSeleccionadas?.filter((e) => e === deleg.idDelegacion).length > 0}
                        id={deleg.idDelegacion}
                        onChange={handleCheckDelegacion}
                        size="small" />

                    } label={
                      <Typography className='checkbox-label'>
                        {deleg.descripcion}
                      </Typography>} />

                  </Grid>;
                })}
              </Grid>
            </div>
          </Grid>
          <Grid size={{ xs: 3.5 }}>
            <div className='delegation-grid-container'>
              <h4 className='seccion-delegation-title'>Delegaciones seleccionadas</h4>
              <FormControl sx={{ width: '100%' }} size="small">
                <InputLabel id="select-delegacion-origen" className='select-delegation'>{textoDelegacionOrigen}</InputLabel>
                <Select
                  className='select-delegation'
                  labelId="select-delegacion-origen"
                  id="DelegacionOrigen"
                  value={delegacionOrigen}
                  label={textoDelegacionOrigen}
                  onChange={handleDelegacionOrigen}
                  sx={{ fontSize: '9pt' }}>

                  {delegaciones?.map((deleg) => {
                    if (delegacionesSeleccionadas?.filter((d) => d === deleg.idDelegacion).length > 0) {
                      return (
                        <MenuItem sx={{ fontSize: '9pt' }} value={deleg.idDelegacion}> {deleg.descripcion} </MenuItem>);

                    }
                  })}
                </Select>
              </FormControl>
              <Grid container columns={{ xs: 1, md: 2 }} spacing={2.5}>
                {regiones?.map((reg) => {
                  let listarRegion = false;
                  const regDeleg = delegaciones?.filter((deleg) => deleg.idRegion === reg.idRegion);
                  let listaDelegaciones = [];

                  regDeleg?.map((deleg) => {
                    if (delegacionesSeleccionadas?.filter((d) => d === deleg.idDelegacion).length > 0) {
                      listarRegion = true;
                      listaDelegaciones.push(deleg);
                    }
                  });

                  if (listarRegion) {
                    return (
                      <Grid size={{ xs: 1 }}>
                        <div className='selected-delegation'>
                          <h4 className='seccion-delegation-title'>
                            {reg.descripcion}
                          </h4>
                          {listaDelegaciones?.map((deleg) => {
                            const disabled = isFromGestionProfesional ?
                              !delegacionesUsuario?.find((d) => d.id === deleg.idDelegacion) :
                              false;
                            return (
                              <Chip
                                className='delegation-chip'
                                size='small'
                                label={deleg.descripcion}
                                onDelete={disabled ? undefined : () => {
                                  setDelegacionesSeleccionadas(
                                    delegacionesSeleccionadas?.filter((d) => d !== deleg.idDelegacion)
                                  );
                                }} />);


                          })}
                        </div>
                      </Grid>);

                  }
                })}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      <Outlet />
    </>);


};